// import { Component, OnInit } from "@angular/core";
// import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
// import { ContratoecertService } from "src/app/services/contratoecert.service";

/*import { ActivatedRoute, Router } from '@angular/router';
import { ContratoService } from 'src/app/services/contrato.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { ToastrService } from 'ngx-toastr';
import { UnificadoService } from 'src/app/services/unificado.service';
import { GlobalVariable } from 'src/app/config/service.config';

import { ProcesoMatricula } from 'src/app/models/procesomatricula.model';*/
import { ConsoleService } from 'src/app/services/console.service';
import { ContratoecertService } from "src/app/services/contratoecert.service";

@Component({
  selector: "app-ecertsuccess",
  templateUrl: "./ecertsuccess.component.html",
})
export class EcertsuccessComponent implements OnInit {
  Idproceso = '';
  titulo = 'Validando estado del contrato';
  body = 'Esperando...';
  progress = true;
  sending: boolean = false;
  private log: any
  //private proceso : ProcesoMatricula

  constructor(
    private route: ActivatedRoute,
    /*
    private router: Router,
    private contratoservice: ContratoService,
    private procesoService: ProcesoMatriculaService,
    private unificadoService: UnificadoService,
    private alerts: ToastrService,*/
    private clog: ConsoleService, 
    private contratoecertservice: ContratoecertService
  ) {
    debugger;
    this.log = this.clog.log('ECERTFAILED')
    this.route.params.subscribe((params) => {
      debugger;
      if (params.id !== '' || params.id !== undefined) {
        this.Idproceso = `${params.id}`;
      }
    });
  }

  ngOnInit(): void {
    debugger;
    this.log('ngOnInit')
    debugger;
    this.route.params.subscribe(
      param => {
        this.log('ngOnInit ds.params.id (ngOnInit) redirect to cancelar_y_redirigir', param.id)
        this.Redireccionar();
      },
    );
  }

  Redireccionar() {
    debugger;
    if (this.Idproceso !== '') {
      debugger;
      this.contratoecertservice
        .getTrazabilidadFirmaECert(this.Idproceso)
        .subscribe(
          (data: any) => {
            debugger;
            console.log("Respuesta de E-Cert: " + JSON.stringify(data));
            if (data.Codigo != null) {
              if (data.Codigo === 1) {
                console.log("Entro en opcion de codigo 1");
                // const proceso = await this.procesoService.GetOrigenProceso(this.Idproceso).toPromise();
                // const urlInicio = `${proceso["UrlRedireccion"]}/inicio`;
                window.location.href = `/proceso/${this.Idproceso}`;
              } else if (data.Codigo === 2) {
                console.log("Entro en opcion de codigo 2");
                setTimeout(function() { window.location.href = "/inicio"; }, 120000);
              } else {
                console.log("Entro en opcion de codigo: " + data.codigo);
                setTimeout(function() { window.location.href = "/inicio"; }, 120000);
              }
            } else {
              console.log("Entro en opcion de codigo es null");
              setTimeout(function() { window.location.href = "/inicio"; }, 120000);
            }
          },
          (err) => {}
        );
    }
  }
}
